import { memo } from "react";

import { Card, Group, Text } from "@mantine/core";
import { BarChart } from "@mantine/charts";

export type DisplayBarChartProps = {
  title: string;
  xAxisLabel: string;
  yAxisLabel: string;
  data: Array<{
    x: string;
    y: number;
  }>;
};

const DisplayBarChart = (props: DisplayBarChartProps) => {
  const { title, xAxisLabel, yAxisLabel, data } = props;

  return (
    <Card withBorder h={280} shadow="xs">
      <Group justify="center" align="center" h={50}>
        <Text c="gray.7" size="sm" fw={700}>
          {title}
        </Text>
      </Group>

      <BarChart
        data={data}
        xAxisLabel={xAxisLabel}
        yAxisLabel={yAxisLabel}
        dataKey="x"
        series={[{ label: yAxisLabel, name: "y", color: "violet" }]}
        withTooltip
        h={230}
        maxBarWidth={20}
        withLegend
      />
    </Card>
  );
};

export default memo(DisplayBarChart);
